<template>
  <div
    class="select-active__value"
    :aria-label="payloadText"
    :title="payloadText"
    :class="classList"
  >
    <template v-if="payload">
      <MProviderIcon
        v-if="payload[iconKey] && !placeholderOnlyName"
        :icon="payload[iconKey]"
        class="select-active__icon"
      />
      <div class="select-active__text-container">
        <div
          v-overflow-title="payload[textKey]"
          class="select-active__text-main"
        >
          <span
            class="select-active__text"
          >
            {{ payloadText }}
          </span>
          <span
            v-if="largeWithIcon && labelText"
            class="select-active__label"
          >
            {{ labelText }}
          </span>
        </div>

        <div
          v-if="largeWithIcon && descriptionText && !placeholderOnlyName"
          class="select-active__description"
        >
          {{ descriptionText }}
        </div>

        <div
          v-if="largeWithIcon && payload.bottomBtnText"
          ref="bottomBtn"
          class="select-active__bottom-btn"
          @click.stop="handleClickBottomBtn"
        >
          {{ payload.bottomBtnText }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import MProviderIcon from 'components/Design/MProviderIcon';

  export default {
    name: 'MSelectControlActive',
    components: {MProviderIcon},
    props: {
      payload: {
        type: Object,
        default: Object
      },
      textKey: {
        type: String,
        default: 'name'
      },
      iconKey: {
        type: String,
        default: 'icon'
      },
      descriptionKey: {
        type: String,
        default: null
      },
      labelKey: {
        type: String,
        default: null
      },
      largeWithIcon: {
        type: Boolean,
        default: false
      },
      placeholderOnlyName: {
        type: Boolean,
        default: false
      },
      idKey: {
        type: String,
        default: 'id'
      },
      showId: {
        type: Boolean,
        default: false
      },
      disabled: Boolean
    },
    computed: {
      classList () {
        return {
          'select-active__value_disabled': this.disabled,
          'select-active__value_placeholder-only-name': this.largeWithIcon && this.placeholderOnlyName,
          'select-active__value_large-with-icon': this.largeWithIcon
        };
      },
      labelText () {
        return this.payload[this.labelKey] || null;
      },
      descriptionText () {
        return this.payload[this.descriptionKey] || null;
      },
      payloadText () {
        if (!this.payload) {
          return null;
        }

        if (this.showId && this.payload[this.idKey]) {
          return `№${this.payload[this.idKey]} ${this.payload[this.textKey]}`;
        }
        return this.payload[this.textKey] || null;
      }
    },
    methods: {
      handleClickBottomBtn (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.$emit('clickBottomBtn', this.payload);
      }
    }
  };
</script>

<style scoped>
  .select-active__value {
    color: var(--secondary-text-color);
    text-overflow: ellipsis;

    overflow: hidden;

    display: flex;

    flex-direction: row;
    align-items: center;
  }

  .select-active__text-main {
    /* padding to prevent cutting of italic symbols */
    padding-right: 2px;
  }

  .select-active__text {
    display: block;
    text-overflow: ellipsis;

    white-space: nowrap;

    overflow: hidden;
  }

  .select-active__icon {
    flex-shrink: 0;

    height: 14px;

    margin-right: 6px;
  }

  .select-active__value_disabled {
    color: var(--gray-text-color);

    & .select-active__icon {
      opacity: 0.5;
    }
  }

  .select-active__value_large-with-icon {
    & .select-active__icon {
      width: 32px;
      height: 32px;

      margin-right: 12px;
    }

    &:not(.select-active__value_placeholder-only-name) .select-active__text {
      font-size: 14px;
      font-weight: 500;

      color: #242424;
      line-height: 16px;
    }

    & .select-active__text-main {
      display: flex;
      align-items: baseline;
    }

    & .select-active__description {
      font-size: 12px;
      font-weight: 400;

      color: #696969;
      line-height: 14px;

      margin-top: 4px;
    }


    & .select-active__bottom-btn {
      width: fit-content;
      margin-top: 4px;
      font-family: var(--main-font-family);
      color: #5585C1;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      letter-spacing: 0;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.7;
      }
    }

    & .select-active__label {
      font-size: 10px;
      font-weight: 500;

      line-height: 11px;

      margin-left: 4px;

      background: linear-gradient(235.1deg, #4965FB -3.88%, #FF3D67 99.79%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .select-active__text-container {
    max-width: 100%;
  }
</style>
